export default function Title(props) {
  return (
    <div className="col-12 d-flex flex-column justify-content-start title mt-5 px-5">
      <h1 className="fw-bolder">{props.heading}</h1>
      <p className="fs-4">{props.paragraph}</p>
    </div>
  );
}
